import Vue from 'vue'
import title from './fragments/title'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const observations = (data) => {
  const observations = data?.observations

  if (!observations) return ''

  return `
    <details>
      ${title(translate(area + 'observation'))}
      <content>
        <p class="body-2 mb-5">
          ${observations}
        </p>
      </content>
    </details>
  `
}

export default observations
